export default "__VITE_ASSET__BGzsyQa0__"